import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const API_URLS = {
  prod: "https://prod-api.nick.academy/api",
  dev: "https://dev-api.nick.academy/api",
};

function getEnv() {
  return localStorage.getItem("api_env") || "prod";
}

const instance = axios.create({
  baseURL: API_URLS[getEnv()],
});

export function switchEnv(env) {
  localStorage.setItem("api_env", env);
  instance.defaults.baseURL = API_URLS[env];
}

export function getCurrentEnv() {
  return getEnv();
}

export function getAuthCookieName() {
  return "jwt_" + getEnv();
}

export function updateAuth(token) {
  instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  cookies.set(getAuthCookieName(), token);
}

export function setAuth(token) {
  instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default instance;
